import Registration from '@/store/modules/registration/constants';
import SuppliersService from '@/services/suppliersService';
import AccountStatus from '@/models/accountStatus';

const suppliersService = new SuppliersService();

export default {
  [Registration.actionTypes.registerSupplier](obj, supplier) {
    return suppliersService.registerSupplier(supplier);
  },

  [Registration.actionTypes.validateConfirmationToken](
    { commit },
    emailConfirmationToken,
  ) {
    return suppliersService.validateConfirmationToken(emailConfirmationToken)
      .then((response) => {
        commit(Registration.mutationTypes.setEmailConfirmationLoading, false);

        return Promise.resolve({
          validationResult: response.validationResult,
          userInfo: response.user,
        });
      })
      .catch(() => {
        commit(Registration.mutationTypes.setEmailConfirmationLoading, false);

        return Promise.resolve({
          validationResult: AccountStatus.NotFound.key,
          userInfo: null,
        });
      });
  },

  [Registration.actionTypes.completeSupplierRegistration]({ commit }, payload) {
    commit(Registration.mutationTypes.setEmailConfirmationLoading, true);
    const { emailConfirmationToken, password } = payload;

    return suppliersService.completeRegistration({
      token: emailConfirmationToken,
      password,
    })
      .then(() => {
        commit(Registration.mutationTypes.setEmailConfirmationLoading, false);

        return Promise.resolve(AccountStatus.Ok.key);
      })
      .catch(() => {
        commit(Registration.mutationTypes.setEmailConfirmationLoading, false);

        return Promise.resolve(AccountStatus.NotFound.key);
      });
  },
};
